/**
 * The body Practice Details posts: the form's values reshaped into the practice record, with the
 * address nested and the Eircode stored without spaces.
 */
export const toPracticeDetailsPayload = ({ values, tenant, practicePicture }) => ({
  name: values.name,
  description: values.type,
  mainPhone: values.mainPhone,
  practiceEmail: values.practiceEmail,
  website: values.website,
  twitter: values.twitter,
  smsName: values.smsName,
  facebook: values.facebook,
  registeredPracticeId: values.registeredPracticeId,
  tenant,
  practicePicture,
  address: {
    id: values.addressId,
    tenant,
    latitude: values.latitude,
    longitude: values.longitude,
    geoHash: values.geoHash,
    addressLine1: values.address,
    addressLine2: values.address2,
    addressLine3: values.address3,
    city: values.city,
    postCode: values.eircode
      ? values.eircode.replace(/\s+/g, "")
      : values.eircode,
    county: values.county,
    country: values.country,
  },
  // Neither may be forced to "": the backend clears a field sent that way. The out-of-hours
  // number is on every referral ahead of the doctor's own (KIN-5); the second phone has no field
  // here and goes back as it was loaded (KIN-2131).
  phone2: values.phone2,
  outOfHoursPhone: values.outOfHoursPhone,
  addressId: values.addressId,
  id: values.id,
});
